export default "__VITE_ASSET__DsoptTCA__"